// React and redux imports
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// Actions imports
import {
    setAiCheckWalletWelcome,
    setAiFirstWelcome,
    setPage,
    setAiTokenAnalyzerWelcome
} from "../../actions";
// Svg icons imports
import { ReactComponent as HomeSvg } from '../../svg-icons/home.svg';
import { ReactComponent as CheckWalletSvg } from '../../svg-icons/wallet-search.svg';
import { ReactComponent as TokenAnalyzerSvg } from '../../svg-icons/token-analyzer.svg';
import { ReactComponent as AiAnalyticsSvg } from '../../svg-icons/ai-analytics.svg';
import { ReactComponent as UpgradeSvg } from '../../svg-icons/upgrade.svg';
// Style import
import './NavBarButton.css';
// Consts imports
import {
    PAGE_HOME,
    PAGE_CHECK_WALLET,
    PAGE_TOKEN_ANALYZER,
    PAGE_AI_ANALYTICS,
    PAGE_UPGRADE
} from "../../consts/consts";

class NavBarButton extends React.Component {

    handleClick = () => {
        const { setPage, buttonName, setAiCheckWalletWelcome, setAiFirstWelcome, setAiTokenAnalyzerWelcome } = this.props;
        setPage(buttonName);

        if (buttonName === PAGE_HOME) {
            setAiFirstWelcome();
        } else if (buttonName === PAGE_CHECK_WALLET) {
            setAiCheckWalletWelcome();
        } else if (buttonName === PAGE_TOKEN_ANALYZER) {
            setAiTokenAnalyzerWelcome();
        }
    };

    render() {

        const { page } = this.props.page;
        const { buttonName } = this.props;

        let buttonIconStyle, buttonSpanStyle;
        if (buttonName === page) {
            buttonIconStyle = "navbar-button-icon navbar-button-icon-active";
            buttonSpanStyle = "navbar-button-label navbar-button-label-active"
        } else {
            buttonIconStyle = "navbar-button-icon";
            buttonSpanStyle = "navbar-button-label";
        }

        if (buttonName === PAGE_HOME) {
            return (
                <div className={'navbar-button-block'} onClick={this.handleClick}>
                    <HomeSvg className={buttonIconStyle}/>
                    <span className={buttonSpanStyle}>
                        Home
                    </span>
                </div>
            );
        } else if (buttonName === PAGE_CHECK_WALLET) {
            return (
                <div className={'navbar-button-block'} onClick={this.handleClick}>
                    <CheckWalletSvg className={buttonIconStyle}/>
                    <span className={buttonSpanStyle}>
                        Check wallet
                    </span>
                </div>
            );
        } else if (buttonName === PAGE_TOKEN_ANALYZER) {
            return (
                <div className={'navbar-button-block'} onClick={this.handleClick}>
                    <TokenAnalyzerSvg className={buttonIconStyle}/>
                    <span className={buttonSpanStyle}>
                        Token analyzer
                    </span>
                </div>
            );
        } else if (buttonName === PAGE_AI_ANALYTICS) {
            return (
                <div className={'navbar-button-block'} onClick={this.handleClick}>
                    <AiAnalyticsSvg className={buttonIconStyle}/>
                    <span className={buttonSpanStyle}>
                        AI analytics
                    </span>
                </div>
            );
        } else if (buttonName === PAGE_UPGRADE) {
            return (
                <div className={'navbar-button-block'} onClick={this.handleClick}>
                    <UpgradeSvg className={buttonIconStyle}/>
                    <span className={buttonSpanStyle}>
                        Upgrade
                    </span>
                </div>
            );
        } else {
            return null;
        }
    }

}

const mapStateToProps = ({ page }) => {
    return { page };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setPage: setPage,
        setAiCheckWalletWelcome: setAiCheckWalletWelcome,
        setAiTokenAnalyzerWelcome: setAiTokenAnalyzerWelcome,
        setAiFirstWelcome: setAiFirstWelcome
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(NavBarButton);
